import type { FaireProductEntity } from "../../entity_types/product";

export const p_1ki50h1wib: FaireProductEntity = {
  token: "p_1ki50h1wib",
  type: "product",
  name: "Flower Market | Honeysuckle Bath Bomb",
  brandToken: "b_4qzg2a3z5n",
  brandName: "Freedom Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/389043438d309a1558702fbefd755a0b080f3d716625ad29daa156c62c8375b5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/79caff57b92f207b41fe327793947260207e79391cc512aa5831e1ca61eb8efb.png",
  ],
  priceDollars: 2.5,
  description:
    "Fresh from the garden, this honeysuckle bath bomb will bring ethereal fragrances to your bathtub. Relax and unwind with the inflammation-reducing powers of honeysuckle.\n\nEach bath bomb is blended with dried flower petals, hand wrapped with white tissue paper and sealed with a round sticker with custom watercolor floral image corresponding to each floral scent.\n\n4.25 oz each\n\nIngredients:\nsodium bicarbonate, citric acid, grapeseed oil, purified water, essential and/ or fragrance oil, flower petals",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:10.008Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
